function toLength(value) {
  return typeof value === "number" ? `${value}px` : value;
}
function withVars(style, vars) {
  const set = Object.entries(vars).filter((entry) => entry[1] != null && entry[1] !== "");
  if (set.length === 0) return style;
  return { ...style, ...Object.fromEntries(set) };
}
export {
  toLength,
  withVars
};
//# sourceMappingURL=styleVars.js.map
